var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmoji5 = function SvgEmoji5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15.88c0 8.008-6.492 14.5-14.5 14.5S.5 23.89.5 15.88C.5 7.873 6.992 1.38 15 1.38s14.5 6.492 14.5 14.5Z",
    fill: "#fff",
    stroke: "#309"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 19.088c-2.472 0-4.113-.288-6.14-.683-.465-.088-1.366 0-1.366 1.365 0 2.73 3.136 6.141 7.506 6.141s7.506-3.411 7.506-6.14c0-1.366-.902-1.455-1.365-1.366-2.028.395-3.668.683-6.141.683Z",
    fill: "#309"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 3.615a3.888 3.888 0 0 0-7.403.212 3.888 3.888 0 0 0-5.896 4.48c.102.286.237.552.394.798 1.626 2.985 6.323 5.083 9.167 5.109 2.198-1.806 4.539-6.388 3.932-9.731a3.929 3.929 0 0 0-.194-.868Zm2.25 0a3.892 3.892 0 0 1 4.963-2.375 3.891 3.891 0 0 1 2.441 2.586 3.888 3.888 0 0 1 5.896 4.48 3.933 3.933 0 0 1-.394.799c-1.626 2.985-6.324 5.083-9.169 5.109-2.197-1.806-4.537-6.388-3.93-9.731.03-.29.093-.582.193-.868Z",
    fill: "#F22F22"
  })));
};
export default SvgEmoji5;